"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _allowed = _interopRequireDefault(require("../utils/allowed"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var TdInner = function TdInner(props) {
  var headers = props.headers,
      children = props.children,
      columnKey = props.columnKey,
      className = props.className,
      colSpan = props.colSpan;
  var classes = "".concat(className || '', " pivoted");

  if (colSpan) {
    return /*#__PURE__*/_react["default"].createElement("td", _extends({
      "data-testid": "td"
    }, (0, _allowed["default"])(props)));
  }

  return /*#__PURE__*/_react["default"].createElement("td", _extends({
    "data-testid": "td"
  }, (0, _allowed["default"])(props), {
    className: classes
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "td-before",
    className: "tdBefore"
  }, headers[columnKey]), children !== null && children !== void 0 ? children : /*#__PURE__*/_react["default"].createElement("div", null, "\xA0"));
};

TdInner.propTypes = {
  children: _propTypes["default"].node,
  headers: _propTypes["default"].shape({}),
  columnKey: _propTypes["default"].number,
  className: _propTypes["default"].string,
  colSpan: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};
TdInner.defaultProps = {
  children: undefined,
  headers: undefined,
  columnKey: undefined,
  className: undefined,
  colSpan: undefined
};
var _default = TdInner;
exports["default"] = _default;